import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './car-model';
import { VehiclePart, VehicleSide } from '../../enums';
import VehicleStateImg from './vehicle-state-img';
import FrontDoorImg from '../../assets/images/car-model/front_door.png';
import RearDoorImg from '../../assets/images/car-model/rear_door.png';
import FrontDoorWindowImg from '../../assets/images/car-model/door_front_window.png';
import RearDoorWindowImg from '../../assets/images/car-model/door_rear_window.png';

interface Props extends VehicleModelProps {
  part: VehiclePart;
  side: VehicleSide;
}

const DOOR_IMGS = {
  [VehiclePart.Front]: FrontDoorImg,
  [VehiclePart.Rear]: RearDoorImg,
};

const DOOR_WINDOW_IMGS = {
  [VehiclePart.Front]: FrontDoorWindowImg,
  [VehiclePart.Rear]: RearDoorWindowImg,
};

const DOOR_STYLES = {
  [VehicleSide.Left]: 0,
  [VehicleSide.Right]: 180,
};

const DOOR_WINDOW_STYLES = {
  [VehiclePart.Front]: 'width: 1.95em; top: 1.2em;',
  [VehiclePart.Rear]: 'width: 1.875em; top: 0.45em;',
};

class VehicleDoor extends React.Component<Props, any> {
  getVehicleItem = () => {
    const { side, part } = this.props;
    return `${side}-${part}-door`;
  };

  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler(this.getVehicleItem());
  };

  render() {
    const { className, part, vehicleState } = this.props;
    const vehicleItem = this.getVehicleItem();

    return (
      <div className={className} onClick={this.clickHandler}>
        <VehicleStateImg
          className={`vehicle-door ${vehicleState[vehicleItem]}`}
          src={DOOR_IMGS[part]}
        />
        <VehicleStateImg
          className={`vehicle-door-window ${vehicleState[vehicleItem]}`}
          src={DOOR_WINDOW_IMGS[part]}
        />
      </div>
    );
  }
}

const StyledVehicleDoor = styled(VehicleDoor)`
  position: relative;
  transform: rotateY(${({ side }) => DOOR_STYLES[side]}deg);

  .vehicle-door {
    width: 5em;
  }

  .vehicle-door-window {
    position: absolute;
    z-index: -1;
    left: 3em;
    ${({ part }) => DOOR_WINDOW_STYLES[part]}
  }
`;

export default StyledVehicleDoor;
